module.exports = __webpack_public_path__ + "static/img/product-swipe42.9900ff25.png";